import { createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import type { AuthContext } from './providers/auth';

export const router = createRouter({
  routeTree,
  context: {
    auth: undefined! as AuthContext,
  },
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
